/**
 * Wrapper around Error that sets the error message and name.
 */
export class RtError extends Error {
  constructor(name: string, message: string) {
    super(message);
    this.name = name;
    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
